<div nxLayout="grid maxwidth" class="inbox">
    <div nxRow>
        <div nxCol="12" class="section-title">
            <h3 nxHeadline="subsection-large" translate>inbox.email-us.basic.section-title</h3>
            <nx-link>
                <a [routerLink]="['']">
                    <nx-icon name="chevron-left"></nx-icon>
                    {{ "inbox.email-us.result.btnText" | translate }}
                </a>
            </nx-link>
        </div>

        <div nxCol="12" class="inbox-card" *ngIf="!(loadingService.isLoading$ | async)">
            <div nxRow class="inbox-card-header" nxRowAlignItems="center">
                <div nxCol="12,12,3" class="new-msg">
                    <a [routerLink]="['/inbox/napiste-nam']">
                        <cpc-button size="x-small" [noHorizontalMargin]="true" [noVerticalMargin]="true">
                            <span translate>inbox.email-us.basic.new-message</span>
                        </cpc-button>
                    </a>
                </div>
                <div nxCol="12,12,9" *ngIf="!this.detailItem">
                    <div class="header-pagination">
                        <div class="bulk-operation {{ ['inbox', 'sent'].includes(selectedComponent) ? '' : 'hidden'}}">
                            <cpc-checkbox (click)="selectMessages($event)" #selectAllCheckbox></cpc-checkbox>
                            <button nxButton="tertiary small" type="button" (click)="deleteMessage()" #deleteBtn
                                disabled>
                                <span translate> inbox.email-us.basic.delete </span>
                            </button>
                        </div>

                        <cpc-pagination *ngIf="this.mailList.list.length > 5" [page]="activePage - 1" [maxPage]="maxPage"
                            [itemsPerPage]="perPage" variant="short" copyPrev="{{'paging.previous' | translate}}"
                            copyOf="{{'paging.of' | translate}}" copyNext="{{'paging.next' | translate}}"
                            (changeItemsPerPage)="handleChangeItemsPerPage($event)"
                            (changePage)="handleChangePage($event)"
                            copyItemPerPage="{{ 'paging.show-per-page' | translate }}"></cpc-pagination>
                    </div>
                </div>
                <div nxCol="12,12,9" *ngIf="this.detailItem">
                    <div class="header-subject">
                        <nx-link nxStyle="block">
                            <a (click)="showList()">
                                <nx-icon name="chevron-left"></nx-icon>
                            </a>
                        </nx-link>
                        <h4 nxHeadline="subsection-small">
                            <small nxHeadline="subsection-xsmall" class="nx-font-weight-light">{{
                                "inbox.email-us.basic.subject" | translate }} </small>{{ firstItemDetail.title }}
                        </h4>
                    </div>
                </div>
            </div>

            <div nxRow>
                <div nxCol="12,12,3" class="side-nav">
                    <cpc-side-nav>
                        <cpc-nav-item *ngFor="let navLink of navList" [icon]="navLink.icon"
                            [disabled]="!navLink.active || (navLink.component == selectedComponent && !this.detailItem)"
                            (click)="changeRoute($event, navLink.component)"
                            class="{{ navLink.component == selectedComponent ? 'active' : '' }}">
                            {{navLink.buttonText | translate}}
                        </cpc-nav-item>
                    </cpc-side-nav>
                </div>
                <div nxCol="12,12,9">
                    <div nxRow *ngIf="!this.detailItem">
                        <div nxCol="12" class="item-box {{selectedComponent}}">
                            <ng-container *ngFor="let mailItem of pagedList">
                                <cpc-mail-item [attachment]="mailItem.attachment" [checkbox]="mailItem.checkbox"
                                    [variant]="mailItem.variant" (changeDetection)="changeDetection($event)"
                                    (click)="showContent(mailItem, $event)" class="cpc-mail-item-wrapper">
                                    <span name>{{ mailItem.name }}</span>
                                    <span title>{{ mailItem.title }}</span>
                                    <span date>{{ mailItem.date | dateFormat }}</span>
                                </cpc-mail-item>
                            </ng-container>
                        </div>

                        <div nxCol="12" class="item-box-pagination">
                            <cpc-pagination *ngIf="this.mailList.list.length > 5" [page]="activePage - 1" [maxPage]="maxPage" [itemsPerPage]="perPage"
                                copyPrev="{{'paging.previous' | translate}}" copyOf="{{'paging.of' | translate}}"
                                copyNext="{{'paging.next' | translate}}"
                                (changeItemsPerPage)="handleChangeItemsPerPage($event)"
                                (changePage)="handleChangePage($event)"
                                copyItemPerPage="{{ 'paging.show-per-page' | translate }}"></cpc-pagination>
                        </div>
                    </div>
                    <div nxRow *ngIf="this.detailItem">
                        <div nxCol="12" class="item-box">
                            <form (submit)="submit($event)">
                                <cpc-message-preview *ngIf="isSent">
                                    <div class="messages-result">
                                        <div class="content">
                                            <cpc-illustration name="confirmationLetter" width="140px">
                                            </cpc-illustration>
                                            <h3 nxHeadline="subsection-large">
                                                {{ "inbox.email-us.result.title" |
                        translate }}
                                            </h3>
                                            <p>
                                                {{ "inbox.email-us.result.text" | translate }}
                                            </p>
                                            <a [routerLink]="['']">
                                                <cpc-button size="x-small">{{ "inbox.email-us.result.btnText" |
                          translate }}
                                                </cpc-button>
                                            </a>
                                        </div>
                                    </div>
                                </cpc-message-preview>

                                <cpc-message-preview *ngIf="!isSent">
                                    <!-- <cpc-message-preview-item [isDrawerOpen]="true"> -->
                                    <cpc-message-preview-item *ngFor="let mailItemDetail of mailItemDetails;"
                                        [isDrawerOpen]="mailItemDetails.length==1 || mailItemDetails[0].checkbox.id == mailItemDetail.checkbox.id">
                                        <cpc-message-preview-header
                                            photo="{{mailItemDetail.fromAsp ? 'assets/images/allianz-logo-eagle.svg' : 'assets/images/user-icon.png' }}"
                                            [attachments]="mailItemDetail.attachment" [date]="mailItemDetail.date"
                                            header>
                                            <span name>{{ mailItemDetail.name }}</span>
                                        </cpc-message-preview-header>
                                        <cpc-message-preview-content content [emailTemplate]="mailItemDetail.content">
                                            <!--<div [innerHTML]="mailItemDetail.content">
                                            </div>-->
                                        </cpc-message-preview-content>

                                        <cpc-message-preview-attachments attachments
                                            *ngIf="showDocuments && mailItemDetail.attachmentId">
                                            <cpc-message-preview-attachment
                                                download="{{ 'inbox.detail.btnDownload' | translate }}"
                                                name="{{ 'inbox.detail.attachment' | translate }}"
                                                (clickDownload)="clickDownload(mailItemDetail.attachmentId)">
                                            </cpc-message-preview-attachment>
                                        </cpc-message-preview-attachments>

                                        <cpc-message-preview-textarea
                                            *ngIf="lastItemDetail.checkbox.id == mailItemDetail.checkbox.id"
                                            [isInReply]="isInReply" [placeholderMessage]="textData.textAreaPlaceHolder"
                                            textarea>
                                        </cpc-message-preview-textarea>
                                    </cpc-message-preview-item>
                                    <cpc-message-preview-footer
                                        *ngIf="isInboxComponent || (isDeletedComponent && lastItemDetail.fromAsp)"
                                        [isInReply]="isInReply" [textData]="getTranslatedTextData()"
                                        (clickReply)="clickReply($event)" (clickAttachment)="clickAttachment()"
                                        (clickDelete)="clickDelete()" (clickSend)="clickSend($event)" footer>
                                    </cpc-message-preview-footer>
                                </cpc-message-preview>
                            </form>
                        </div>

                        <div nxCol="12" class="item-info">
                            <p>
                                <span translate>inbox.detail.questionText</span>&nbsp;<nx-link
                                    nxStyle="block icon-right"><a [routerLink]="['/kontaktujte-nas']" translate>
                                        <nx-icon name="arrow-right"></nx-icon>inbox.detail.questionTextAnchor
                                    </a></nx-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>